import { render, staticRenderFns } from "./ProductSpecsCreate.vue?vue&type=template&id=3ef1ff08"
import script from "./ProductSpecsCreate.vue?vue&type=script&lang=js"
export * from "./ProductSpecsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports